import { Form, Spin } from "antd";
import { useState, useRef, useEffect } from "react";
import { Button, Input, Modal, Switch } from "antd";

import { useParams } from "react-router-dom";
import {
  CaAdminMenu,
  SecondaryNavCaAdmin,
} from "../../../components/AdminComponents/MenuItems";

import "../tableStyling.css";
import { CloseOutlined, FormOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import ParentTable from "../../../components/AdminComponents/Modals/ParentTable";
import { setFirstTable } from "../../../store/slices/firstTable";
import CaSideNav from "../../../components/AdminComponents/CaSideNav";
import SecondaryNav2 from "../../../components/AdminComponents/SecondaryNav2";
import Axios from "../../../api/Axios";
import { message } from "antd";
import { setClientData } from "../../../store/slices/OrgDetail";
import { getUpdateStatus } from "../../../components/AdminComponents/ViewUpdateIndex";
import CommonTopDetails from "../../../components/AdminComponents/CommonTopDetails";
const { Item } = Form;

const StructureCA = () => {
  //
  const dispatch = useDispatch();
  const { id } = useParams();
  const [manager, setManager] = useState();
  const [managerL2, setManagerL2] = useState();
  const [managerL3, setManagerL3] = useState();

  //   const [hhh, setHH] = useState([
  //     [false, false],
  //     [false, false],
  //     [false, false],
  //   ]);
  const [top, setTop] = useState(false);
  const [data, setData] = useState();
  // const handleParentRowClose = (key) => {
  //   setExpandedRows({
  //     ...expandedRows,
  //     [key]: true,
  //   });
  // };
  // const [secondRowIndex, setsecondRowIndex] = useState(-1);
  // const setRowSecond = (index) => {
  //   setsecondRowIndex(index);
  // };
  //
  useEffect(() => {
    // Set the initial state of the reducer
    if (data) {
      dispatch(setFirstTable({ length: data?.length, value: false }));
    }
  }, [dispatch, data]);

  //   const EditableCell = ({
  //     editing,
  //     dataIndex,
  //     title,
  //     inputType,
  //     record,
  //     index,
  //     children,
  //     ...restProps
  //   }) => {
  //     const inputNode =
  //       inputType === "select" ? (
  //         <Select placeholder="Select application">
  //           {applications?.map((app) => (
  //             <Option key={app.id} value={app.id}>
  //               {app.name}
  //             </Option>
  //           ))}
  //         </Select>
  //       ) : (
  //         <Input />
  //       );
  //     return (
  //       <td {...restProps}>
  //         {editing ? (
  //           <Form.Item
  //             name={dataIndex}
  //             style={{
  //               margin: 0,
  //             }}
  //             rules={[
  //               {
  //                 required: true,
  //                 message: `Please Input ${title}!`,
  //               },
  //             ]}
  //           >
  //             {inputNode}
  //           </Form.Item>
  //         ) : (
  //           children
  //         )}
  //       </td>
  //     );
  //   };

  const showModal = () => {
    setOpen(true);
  };
  const formRef2 = useRef();
  const [open, setOpen] = useState(false);

  const [loading, setLoading] = useState(false);
  const handleCancel = () => {
    setOpen(false);
    formRef2.current.resetFields();
  };
  const handleOk = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setOpen(false);
    }, 3000);
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const onFinish2 = async (values) => {
    values.client_id = namingData.id;
    values.name = namingData.name;
    //console.log(values);
    try {
      await Axios.put(
        `/organization/${userInfo.data.organization.id}/`,
        values,
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      LoadUser21();
      //console.log(res);
      CreateSuccessfull("Hierarchies have been edited");
      setOpen(false);
    } catch (err) {
      //console.log(err);
      CreateFailed(err?.response?.data?.detail || "Hierarchies edit failed");
    }
  };
  const LoadL1Manager = async () => {
    try {
      const res = await Axios.get(
        `userlist/?is_superadmin=False&status=True&organization_id=${parseInt(
          userInfo.data.organization.id
        )}&role=level1_manager`
      );
      //console.log(res.data);
      setManager(res.data);
    } catch (err) {
      //console.log(err);
    }
  };
  const LoadL2Manager = async () => {
    try {
      const res = await Axios.get(
        `userlist/?is_superadmin=False&status=True&organization_id=${parseInt(
          userInfo.data.organization.id
        )}&role=level2_manager`
      );
      //console.log(res.data);
      setManagerL2(res.data);
    } catch (err) {
      //console.log(err);
    }
  };
  const LoadL3Manager = async () => {
    try {
      const res = await Axios.get(
        `userlist/?is_superadmin=False&status=True&organization_id=${parseInt(
          userInfo.data.organization.id
        )}&role=level3_manager`
      );
      //console.log(res.data);
      setManagerL3(res.data);
    } catch (err) {
      //console.log(err);
    }
  };
  const LoadUser21 = async () => {
    try {
      const res = await Axios.get(
        `/organization/${userInfo.data.organization.id}/`
      );

      const { client_id, name, dep_label, div_label, entity_label } = res.data;
      dispatch(
        setClientData({ client_id, name, dep_label, div_label, entity_label })
      );
    } catch (err) {
      //console.log(err);
    }
  };
  const userInfo = useSelector((state) => state.user);
  const updateAuth = getUpdateStatus(userInfo, 0, 4);
  // eslint-disable-next-line no-unused-vars
  const [itemsLength, setItemsLength] = useState();
  const [filterData, setFilterData] = useState({
    url: `/orgstructure/${userInfo.data.organization.id}/`,
    search: "",
    active: true,
  });
  const { url, search, active } = filterData;
  const handleSearchChange = (event) => {
    setFilterData((prevData) => ({
      ...prevData,
      search: event.target.value,
      currentPage: 1,
    }));
  };

  const LoadUser = async () => {
    let passUrl = url;
    let doNothing = false;
    if (search?.length > 0) {
      if (search.length > 2) {
        passUrl += `?status=${active ? "True" : "False"}&search=${search}`;
      } else {
        doNothing = true;
      }
    } else {
      passUrl += `?status=${active ? "True" : "False"}`;
    }
    if (!doNothing) {
      setLoading(true);
      try {
        const res = await Axios.get(passUrl);
        setData(res.data);
        //console.log(res.data);
        setItemsLength(res.data);
        setLoading(false);
        //console.log(data);
      } catch (err) {
        //console.log(err);
      }
    }
  };
  useEffect(() => {
    LoadUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData]);
  useEffect(() => {
    LoadL1Manager();
    LoadL2Manager();
    LoadL3Manager();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [messageApi, contextHolder] = message.useMessage();
  const CreateSuccessfull = (props) => {
    messageApi.open({
      type: "success",
      content: `${props}.`,
      duration: 5,
    });
    setLoading(true);
    LoadUser();
  };

  const CreateFailed = (props) => {
    messageApi.open({
      type: "error",
      content: `${props}.`,
      duration: 5,
    });
  };
  const namingData = useSelector((state) => state.orgdeatil);
  //console.log(namingData);
  const handleSwitchChange = () => {
    setFilterData((prevData) => ({
      ...prevData,
      active: !prevData.active,
      search: "",
    }));
  };

  return (
    <>
      <CaSideNav props={CaAdminMenu}>
        {contextHolder}
        <SecondaryNav2 id={parseInt(id)} menuItems={SecondaryNavCaAdmin} />
        <CommonTopDetails
          title={active ? "Hierarchy" : "Inactive Hierarchy"}
          titleSuffix={`${data?.length || 0} ${
            namingData.entity_label || ""
          }(s)`}
          searchPlaceholder="Search by..."
          searchAction={handleSearchChange}
          showAddButton={false}
          marginPass="15px"
          customContent={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <Switch
                style={{
                  backgroundColor: active ? "#50C878" : "#FF0000",
                  minWidth: "90px",
                }}
                checked={active}
                onChange={handleSwitchChange}
                disabled={loading}
                checkedChildren="ACTIVE"
                unCheckedChildren="INACTIVE"
              />
              <Button
                type="primary"
                htmlType="button"
                onClick={showModal}
                disabled={!updateAuth}
              >
                Edit Level Labels
              </Button>
            </div>
          }
        />
        <div className="form-container-2">
          <Spin spinning={loading}>
            <ParentTable
              top={top}
              setTop={setTop}
              data={data}
              CreateSuccessfull={CreateSuccessfull}
              CreateFailed={CreateFailed}
              active={active}
              manager={manager}
              managerL2={managerL2}
              managerL3={managerL3}
            />
          </Spin>
          <Modal
            title={<p className="modal-heading">EDIT LEVEL LABELS</p>}
            centered
            // open={modalOpen}
            // onOk={() => setModalOpen(false)}
            // onCancel={() => setModalOpen(false)}
            onOk={handleOk}
            onCancel={handleCancel}
            open={open}
            footer={[]}
          >
            <Form
              onFinish={onFinish2}
              style={{ marginTop: "3rem" }}
              ref={formRef2}
            >
              <Item
                initialValue={namingData?.entity_label}
                label={
                  <p
                    className="modal-text"
                    style={{
                      fontSize: "1.6rem",
                      minWidth: "14rem",
                      textAlign: "start",
                    }}
                  >
                    TOP LEVEL
                  </p>
                }
                name="entity_label"
                // rules={[
                //   { required: true, message: "Please input a Hirearcy name" },
                // ]}
              >
                <Input
                  placeholder="Enter Top Level"
                  initialValue={namingData.entity_label}
                />
              </Item>
              <Item
                initialValue={namingData.div_label}
                label={
                  <p
                    className="modal-text"
                    style={{
                      fontSize: "1.6rem",
                      minWidth: "14rem",
                      textAlign: "start",
                    }}
                  >
                    MIDDLE LEVEL
                  </p>
                }
                name="div_label"
                // rules={[
                //   { required: true, message: "Please input a hirearcy ID" },
                //   {
                //     max: 100,
                //     message: "Title should not exceed 100 characters",
                //   },
                // ]}
              >
                <Input
                  placeholder="Enter Middle level"
                  initialValue={namingData.div_label}
                />
              </Item>
              <Item
                initialValue={namingData.dep_label}
                label={
                  <p
                    className="modal-text"
                    style={{
                      fontSize: "1.6rem",
                      minWidth: "14rem",
                      textAlign: "start",
                    }}
                  >
                    BOTTOM LEVEL
                  </p>
                }
                name="dep_label"
              >
                <Input
                  placeholder="Enter Bottom level"
                  initialValue={namingData.dep_label}
                />
              </Item>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  height: "2rem",
                  marginTop: "1rem",
                  marginBottom: "1rem",
                }}
              >
                <Form.Item style={{ marginRight: "1rem" }}>
                  <Button key="back" onClick={handleCancel}>
                    <CloseOutlined />
                    Cancel
                  </Button>
                </Form.Item>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{
                      background: "#f58029",
                      fontWeight: "600",
                    }}
                    className="save-update-btn"
                  >
                    Update
                    <FormOutlined />
                  </Button>
                </Form.Item>
              </div>
            </Form>
          </Modal>
        </div>
      </CaSideNav>
    </>
  );
};
export default StructureCA;
